if (!customElements.get('theme-cart-button')) {
  customElements.define('theme-cart-button', class extends HTMLElement {
    connectedCallback() {
      this.submitButton = this.parentElement.querySelector('[data-cart-button]');
      if (!this.submitButton) return;
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data.sectionId !== this.dataset.section) return;
        const nextButton = data.html.getElementById(this.submitButton.id);
        const price = this.submitButton.querySelector('[data-cart-price]');
        const nextPrice = nextButton?.querySelector('[data-cart-price]');
        if (price && nextPrice) price.innerHTML = nextPrice.innerHTML;
        if (!this.submitButton.disabled && this.submitButton.dataset.cartLabel) {
          this.submitButton.querySelector('span').textContent = this.submitButton.dataset.cartLabel;
        }
      });
    }

    disconnectedCallback() {
      this.unsubscribe?.();
    }
  });
}
